import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { ShopTiles } from '../components/home/ShopTiles';
import { RitualSetFeature } from '../components/home/RitualSetFeature';
import { CategoryShortcuts } from '../components/home/CategoryShortcuts';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { BrandStrip } from '../components/home/BrandStrip';
import { ProductSection } from '../components/shop/ProductSection';
import { collections } from '../data/collections';
import { productsForCollection } from '../utils/products';
export function Home() {
  const bestsellers = collections.find(c => c.slug === 'bestsellers');
  const top = bestsellers ? productsForCollection(bestsellers).filter(p => p.category !== 'sets').slice(0, 4) : [];
  return <>
      <HomeHero data-id="element-491" data-mp="3kvtl5drznpxf" />
      <ShopTiles data-id="element-492" data-mp="3ku8rdqdi0b0m" />
      <ProductSection title="Bestsellers" subtitle="Waar onze klanten steeds weer voor terugkomen." link={{
      to: '/collectie/bestsellers',
      label: 'Alle bestsellers'
    }} products={top} data-id="element-493" data-mp="3kuqv182hprik" />
      <RitualSetFeature data-id="element-494" data-mp="30up09zqtaace" />
      <CategoryShortcuts data-id="element-495" data-mp="2vxybmo0xy6fd" />
      <ReviewsSection data-id="element-496" data-mp="2vyq7lzyga666" />
      <BrandStrip data-id="element-497" data-mp="2vy818ai2qbkj" />
    </>;
}